import { ALIGNMENT } from '../../../utils/constants/alignment';

const { LEFT, RIGHT } = ALIGNMENT;

// One entry per Grid column. `key` is unique and used as the row key.
// `sortField` is the raw play field sorting reads (when isSortable).
export const PLAYS_GRID_COLUMNS = [
  { key: 'gameIndex', label: '#', alignment: LEFT, isSortable: true },
  {
    key: 'driveGameIndex',
    label: 'DRIVE #',
    alignment: LEFT,
    isSortable: true,
    sortField: 'drive.gameIndex',
  },
  { key: 'driveIndex', label: 'PLAY #', alignment: LEFT, isSortable: true },
  { key: 'name', label: 'DESCRIPTION', alignment: LEFT, isSortable: true },
  { key: 'quarter', label: 'QTR', alignment: LEFT, isSortable: true },
  {
    key: 'clock',
    label: 'CLOCK',
    alignment: LEFT,
    isSortable: true,
    sortField: 'quarterClockRemaining',
    format: 'clock',
  },
  {
    key: 'offense',
    label: 'OFF',
    alignment: LEFT,
    isSortable: true,
    sortField: 'offenseTeam.shortName',
    format: 'team',
  },
  {
    key: 'defense',
    label: 'DEF',
    alignment: LEFT,
    isSortable: true,
    sortField: 'defenseTeam.shortName',
    format: 'team',
  },
  {
    key: 'down',
    label: 'DOWN',
    alignment: LEFT,
    isSortable: true,
    format: 'down',
  },
  {
    key: 'yardsToGo',
    label: 'TO GO',
    alignment: RIGHT,
    isSortable: true,
    format: 'decimal',
  },
  {
    key: 'yardLine',
    label: 'YARD LN',
    alignment: RIGHT,
    isSortable: true,
    format: 'yardLine',
  },
  {
    key: 'type',
    label: 'TYPE',
    alignment: LEFT,
    isSortable: true,
    format: 'playType',
  },
  {
    key: 'yardsNet',
    label: 'NET YDS',
    alignment: RIGHT,
    isSortable: true,
    format: 'yardsWon',
  },
  {
    key: 'yardsRun',
    label: 'RUN YDS',
    alignment: RIGHT,
    isSortable: true,
    format: 'decimal',
  },
  {
    key: 'passYardsAir',
    label: 'PASS AIR YDS',
    alignment: RIGHT,
    isSortable: true,
    format: 'decimal',
  },
  {
    key: 'scrimmageEpa',
    label: 'EPA',
    alignment: RIGHT,
    isSortable: true,
    format: 'decimal',
  },
  {
    key: 'explosive',
    label: 'EXP',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'success',
    label: 'SUCC',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'firstDownWon',
    label: '1ST D WON',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'touchdownWon',
    label: 'TD WON',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  { key: 'pointsWon', label: 'PTS WON', alignment: RIGHT, isSortable: true },
  { key: 'turnoverType', label: 'TO TYPE', alignment: LEFT, isSortable: true },
  {
    key: 'downNegated',
    label: 'DOWN NEG',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'qbHit',
    label: 'QB HIT',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'qbSacked',
    label: 'QB SCK',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'offensivePersonnel',
    label: 'OFF PERS',
    alignment: LEFT,
    isSortable: true,
    format: 'offPers',
  },
  { key: 'backfieldNumRbs', label: 'RBS', alignment: RIGHT, isSortable: true },
  {
    key: 'formationGroup',
    label: 'OFF FORM',
    alignment: LEFT,
    isSortable: true,
    format: 'enum',
  },
  {
    key: 'defensivePersonnel',
    label: 'DEF PERS',
    alignment: LEFT,
    isSortable: true,
    format: 'defPers',
  },
  {
    key: 'defensiveCoverage',
    label: 'DEF COV',
    alignment: LEFT,
    isSortable: true,
    format: 'enum',
  },
  {
    key: 'mofo',
    label: 'MOFO',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
    description:
      'Defense showed an open middle of the field (MOFO) at the snap',
  },
  {
    key: 'offensePenaltyAccepted',
    label: 'OFF PEN ACC',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'defensePenaltyAccepted',
    label: 'DEF PEN ACC',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'penaltyOffset',
    label: 'PEN OFF',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  { key: 'penaltyYards', label: 'PEN YDS', alignment: RIGHT, isSortable: true },
  {
    key: 'penaltyFirstDown',
    label: 'PEN 1D',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'penaltyDownLoss',
    label: 'PEN D LOSS',
    alignment: LEFT,
    isSortable: true,
    format: 'bool',
  },
  {
    key: 'penalties',
    label: 'PENS',
    alignment: LEFT,
    isSortable: true,
    format: 'penalties',
  },
  {
    key: 'drawnPenaltyPlayer',
    label: 'DRAWN PENALTY',
    alignment: LEFT,
    isSortable: true,
    description: 'Player credited with drawing a penalty on this play',
  },
  { key: 'homeScore', label: 'HOME SCORE', alignment: RIGHT, isSortable: true },
  { key: 'awayScore', label: 'AWAY SCORE', alignment: RIGHT, isSortable: true },
];

// Selection is enabled, so the leading checkbox is td:nth-of-type(1) and the
// row-number (#) column is td:nth-of-type(2). Kitbag's Table treats a single
// number as one sticky column at that 1-based index (not "first N"), so pin
// both explicitly as the fixed row identity.
export const PLAYS_GRID_STICKY_COLUMNS = [
  { index: 1, width: 2 }, // selection checkbox (~32px)
  { index: 2, width: 3.5 }, // row number (#)
];
